export default {
  namespaced: true,
  state: {
    processoSelecionado: null,
    datasRemocao: [],
    servidorSolicitante: null,
  },
  getters: {
    processoSelecionado(state) {
      return state.processoSelecionado;
    },
    datasRemocao(state) {
      return state.datasRemocao;
    },
    getServidorSolicitante(state) {
      return state.servidorSolicitante;
    },
  },
  mutations: {
    setProcessoSelecionado(state, payload) {
      state.processoSelecionado = payload;
    },
    setDatasRemocao(state, payload) {
      state.datasRemocao = payload;
    },
    setServidorSolicitante(state, payload) {
      state.servidorSolicitante = payload;
    },
  },
  actions: {},
};
